import { render } from "./View.vue?vue&type=template&id=2db842e4&scoped=true"
import script from "./View.vue?vue&type=script&lang=ts"
export * from "./View.vue?vue&type=script&lang=ts"

import "./View.vue?vue&type=style&index=0&id=2db842e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2db842e4"

export default script